/**
 * Configurazione centrale Supabase per file Node.js ESM
 * Mirror JS di supabaseConfig.ts per i file .js che girano direttamente in Node.js
 * 
 * ⚠️ NON eliminare questo file - è usato dai file .js del server SSR
 */

export const SUPABASE_CONFIG = {
  PROJECT_ID: 'qldjmxfimvxskdbastkx',
  URL: 'https://qldjmxfimvxskdbastkx.supabase.co',
  ANON_KEY: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFsZGpteGZpbXZ4c2tkYmFzdGt4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk3Mjk5ODUsImV4cCI6MjA1NTMwNTk4NX0.yXHezaqqVqD6tK9IhkJ-Lw6FaE1mhjt-hNCsu7Tvf-w'
};
